import styled, { css } from 'styled-components';

// Cloned from FormulaInput/styled.ts, minus the draft-js-plugins `.mnw6qvm` dropdown rule
// (the Tiptap suggestion popup is rendered+styled separately) and `.DraftEditor-root`
// swapped for Tiptap's `.ProseMirror`.
export const Div = styled.div<{ $error?: boolean }>`
  .fi-root {
    box-sizing: border-box;
    border: 1px solid ${({ theme }) => theme.colors.stroke};
    background: ${({ theme }) => theme.colors.cultured};
    cursor: text;
    padding: 10px 12px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.prussianBlue};
    font-size: 14px;
    font-weight: 500;

    &__editor {
      flex: 1;
    }

    &__adorment-start {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 7px;
      height: 22px;
    }

    .ProseMirror {
      flex: 1;
      outline: none;
      white-space: pre-wrap;
      word-break: break-word;

      /* ProseMirror wraps content in <p>, which carries the UA's default ~1em margin and
         inflates the field. Collapse it to a single-line input look. */
      > p {
        margin: 0;
      }
    }
  }

  .fi-helper-text {
    margin-top: 4px;
    margin-left: 10px;
  }

  .fi-result {
    display: flex;
    align-items: center;
    font-size: 14px;
    gap: 10px;
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    position: absolute;
  }
  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
    position: absolute;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.aliceBlue};
    position: absolute;
  }

  ${({ $error }) =>
    $error &&
    css`
      .fi-root {
        border: 1px solid ${({ theme }) => theme.colors.error};
      }
      .fi-helper-text {
        color: ${({ theme }) => theme.colors.error};
      }
    `}

  ${({ theme }) => theme.breakpoints.down('md')} {
    .fi-root {
      padding: 8px 12px;
    }
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    .fi-root {
      font-size: 12px;
      padding: 8px 10px;
      &__adorment-start {
        height: 23px;
        transform: translateY(0.5px);
      }
    }
  }
`;
